import {CommonMessages} from '../common.messages';

export const ClientAccessRightsMessages = {
    GetClientFailed: {
        key: 'GetClientFailed',
        message: 'Error while communication with the server. Can\'t load client details.'
    },
    GetUserWithPermissionsFailed: {
        key: 'GetUserWithPermissionsFailed',
        message: 'Error while communication with the server. Unable to get assigned client permissions.'
    },
    GetPortalPermissionsFailed: {
        key: 'GetPortalPermissionsFailed',
        message: 'Error while communication with the server. Can\'t load Portal permissions.'
    },
    GetPortalPermissionsNoData: {
        key: 'GetPortalPermissionsNoData',
        message: 'Error while communication with the server. Can\'t find portals permissions.'
    },
    GetAssignedAccountsRightsFailed: {
        key: 'GetAssignedAccountsRightsFailed',
        message: 'Error while communication with the server. Can\'t load assigned accounts access rights.'
    },
    GetSupervisedRightsFailed: {
        key: 'GetSupervisedRightsFailed',
        message: 'Error while communication with the server. Can\'t load supervised rights.'
    },
    UpdateUserPermissionsFailed: {
        key: 'UpdateUserPermissionsFailed',
        message: 'Update User\'s Access Rights Failed'
    },
    UpdateAccountRightsFailed: {
        key: 'UpdateAccountRightsFailed',
        message: 'Update access rights for account with reference <<reference>> failed.'
    },
    UpdateSupervisedRightsFailed: {
        key: 'UpdateSupervisedRightsFailed',
        message: 'Update supervised rights to client <<name>> failed.'
    },
    UnAssignSupervisedRightsFailed: {
        key: 'UnAssignSupervisedRightsFailed',
        message: 'Unassignment supervised rights from client <<name>> failed.'
    },
    NonActiveClient: {
        key: 'NonActiveClient',
        message: 'Can\'t load client access rights of non active client.'
    },
    PublishRightRefused: {
        key: 'PublishRightRefused',
        message: 'The server refused the rights: Public Portfolio Publishing can be granted only on the account owner\'s row of a trading account.'
    },
    PublicTradersSwitchedOff: {
        key: 'PublicTradersSwitchedOff',
        message: 'Public Traders is switched off, so Public Portfolio Publishing cannot be changed right now.'
    },
    PublishRightForbidden: {
        key: 'PublishRightForbidden',
        message: 'Only an active operator with the users update-rights permission can change Public Portfolio Publishing.'
    },
    ...CommonMessages
};
